<div class="central-content">
  <div class="heading-image mb-30">
  </div>

  <div class="unsupported-device__wrapper mx-auto p-30 text-center">
    <div class="vo-heading-bold-24 my-15">Device information</div>
    <div class="vo-body-regular-14 my-30">
        <ng-container *ngFor="let info of infoList | keyvalue">
          <div class="d-flex mb-15">
            <div class="flex-1 text-md-left">
              {{info.key}}
            </div>
            <div class="flex-1 text-md-left">
              {{info.value}}
            </div>
          </div>  
        </ng-container>
    </div>
  </div>
</div>
